import React from "react";

import { ActiveTabWithoutAll } from "chq";
import { Trans } from "app/utils";
import { Button } from "@culturehq/components";

import ChqModalConfirm from "components/common/ChqModalConfirm";

const CONFIRM_CHANGE_TAB = "If you change the media type tab, you will lose the currently selected media, do you want to continue?";

type PromptMediaTypeTabProps = {
  activeTab: ActiveTabWithoutAll;
  label: string;
  onChangeActiveTab: (tab: ActiveTabWithoutAll) => void;
  hasSelectedMedia: boolean;
  tab: string;
};

const PromptMediaTypeTab: React.FC<PromptMediaTypeTabProps> = ({
  activeTab,
  label,
  onChangeActiveTab,
  hasSelectedMedia,
  tab
}) => {
  const handleTabChange = (onTrigger: () => void, tab: ActiveTabWithoutAll) => {
    // by default, selected media is the user image, we need to validate that case
    if (hasSelectedMedia) {
      onTrigger();
    } else {
      onChangeActiveTab(tab);
    }
  };

  return (
    <ChqModalConfirm
      onAccept={() => onChangeActiveTab(tab)}
      trigger={(onTrigger: () => void) => (
        <Button
          className={`MainContainerIntelligence__Toggle-button ${activeTab === tab ? "active" : ""}`}
          onClick={() => handleTabChange(onTrigger, tab)}
        >
          <Trans>{label}</Trans>
        </Button>
      )}
    >
      <Trans>{CONFIRM_CHANGE_TAB}</Trans>
    </ChqModalConfirm>
  );
};

export default PromptMediaTypeTab;
